import { QuestionBase } from "src/app/core/components/dynamic-form/models/question-base";

export const searchConfigLegal: QuestionBase[] = [
  {
    key: "name",
    label: "Ragione Sociale",
    required: false,
    controlType: "textbox",
    placeholder: "Inserire Ragione Sociale",
    size: "sm-6",
    type: "text",
  },
  {
    key: "taxNumber",
    label: "Codice Fiscale",
    placeholder: "Inserisci Codice Fiscale",
    size: "sm-6",
    required: false,
    controlType: "textbox",
    type: "",
  },
  {
    key: "vatNumber",
    label: "Partita IVA",
    placeholder: "Inserisci Partita IVA",
    size: "sm-6",
    required: false,
    controlType: "textbox",
    type: "",
  },

];
